(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gu-size-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gu-product-wishlist')) {
  customElements.define('gu-product-wishlist', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.section = this.closest('.shopify-section');
      this.button.addEventListener('click', () => this.toggle());
      this.section.addEventListener('change', () => {
        if (this.swat) setTimeout(() => this.refresh(), 100);
      });
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(swat => {
        this.swat = swat;
        this.refresh();
        if (swat.JSEvents?.variantChanged) {
          swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, () => {
            if (this.isConnected) this.refresh();
          });
        }
      });
    }
    productData() {
      const selected = Array.from(this.section.querySelectorAll('variant-picker input:checked, variant-picker select')).map(el => el.value);
      const variant = this.variants.find(v => selected.length === v.options.length && v.options.every((o, i) => o === selected[i]))
        || this.variants.find(v => String(v.id) === this.dataset.variantId) || this.variants[0];
      return {empi: Number(this.dataset.productId), epi: variant.id, du: this.dataset.productUrl, dt: this.dataset.productTitle, pr: variant.pr, iu: variant.iu};
    }
    render(added) {
      this.button.setAttribute('aria-pressed', String(added));
      const label = added ? this.dataset.remove : this.dataset.add;
      this.button.setAttribute('aria-label', label);
      this.button.querySelector('span').textContent = label;
      this.button.disabled = false;
    }
    refresh() {
      const product = this.productData();
      this.swat.fetch(items => {
        if (String(this.productData().epi) !== String(product.epi)) return;
        this.render(items.some(item => String(item.empi) === String(product.empi) && String(item.epi) === String(product.epi)));
      });
    }
    toggle() {
      if (!this.swat || this.button.disabled) return;
      const product = this.productData();
      const added = this.button.getAttribute('aria-pressed') === 'true';
      this.button.disabled = true;
      this.status.textContent = '';
      const fail = () => {this.button.disabled = false; this.status.textContent = this.dataset.error;};
      try {
        const action = added ? 'removeFromWishList' : 'addToWishList';
        this.swat[action](product, () => this.refresh(), fail);
      } catch (error) {fail();}
    }
  });
}

document.addEventListener('click', event => {
  const link = event.target.closest('[data-gu-information]');
  if (!link) return;
  const section = link.closest('.shopify-section');
  const row = section?.querySelector('gu-product-information [data-row="' + link.dataset.guInformation + '"]');
  if (!row) return;
  event.preventDefault();
  row.open = true;
  row.querySelector('summary').focus({preventScroll: true});
  row.scrollIntoView({block: 'start', behavior: 'auto'});
});

if (!customElements.get('gu-product-information')) {
  customElements.define('gu-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.organised) return;
      this.dataset.organised = 'true';
      const source = this.querySelector('[data-description]');
      if (!source) return;
      const category = text => {
        if (/\b(model|models|saffron|imogen)\b.*\b(wear|wears|wearing|height|tall)\b/i.test(text)) return 'model';
        if (/\b(composition|wash|washing|hand wash|tumble|bleach|iron|dry clean)\b|\d+(?:\.\d+)?\s*%/i.test(text)) return 'care';
        if (/\b(true to size|size up|size down|between sizes|recommend.*siz|oversized.*fit|relaxed fit)\b/i.test(text)) return 'fit';
        return null;
      };
      for (const element of [...source.querySelectorAll('p,li')]) {
        if (element.querySelector('p,li,table,img')) continue;
        const text = element.textContent.trim();
        const destination = category(text);
        if (!destination) continue;
        const target = this.querySelector('[data-' + destination + ']');
        if (element.tagName === 'P' && !element.querySelector('a') && text.split(/(?<=[.!?])\s+/).length > 1) {
          const remainder = [];
          for (const sentence of text.split(/(?<=[.!?])\s+/)) {
            const bucket = category(sentence);
            if (!bucket) { remainder.push(sentence); continue; }
            const paragraph = document.createElement('p');
            paragraph.textContent = sentence;
            this.querySelector('[data-' + bucket + ']').append(paragraph);
            this.querySelector('[data-row="' + bucket + '"]').hidden = false;
          }
          element.textContent = remainder.join(' ');
          if (!element.textContent.trim()) element.remove();
        } else {
          const paragraph = document.createElement('p');
          paragraph.innerHTML = element.innerHTML;
          target.append(paragraph);
          element.remove();
          this.querySelector('[data-row="' + destination + '"]').hidden = false;
        }
      }
      for (const empty of source.querySelectorAll('ul,ol,p')) {
        if (!empty.textContent.trim() && !empty.querySelector('img')) empty.remove();
      }
      if (!source.textContent.trim() && !source.querySelector('img')) this.querySelector('[data-row="description"]').hidden = true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
